export default __webpack_public_path__ + "static/media/ic_replace.7f5bfe31.svg";